/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';

export default {
    name: 'fyjsMore',
    components: {ccTab},
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'发展历程',
                key:'fyjs',
                path:'/fyjs'
            }, {
                name:'法官介绍',
                key:'fgjs'
            }]),
            tabList: [
                {
                    name: '最高人民法院法官',
                    code: 'fg'
                }
            ],
            activeTab: 'fg',
            data:[]
        };
    },
    mounted() {
        if (this.$route.query.name === '最高人民法院') {
            this.tabList[0].name = `${this.$route.query.name}民四庭法官`;
        } else {
            this.tabList[0].name = `${this.$route.query.name}法官`;
        }
        this.getData();
    },
    methods: {
        // 获取列表的数据
        getData(queryInfo) {
            let params = {code: this.$route.query.code};
            if (queryInfo) {
                params = {
                    ...queryInfo,
                    ...params
                };
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.fyjs.fglb,
                params: params
            }).then((res) => {
                this.data = res.data;
            });
        }
    }
};

